import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";

import {
  GET_REPORT_DATA_REQUEST,
  getReportDataSuccess,
  getReportDataFailure,
} from "./actions";

function* getEmployeeEarningReportDataSaga(action) {
  try {
    const { searchParams } = action.payload;
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_API_DOTNET_URL}/AdvanceSearch/global/EmployeeEarningsStatement-Info`,
      {
        tableName: "",
        searchParams: JSON.stringify(searchParams),
        columns: "*",
        pageNumber: 1,
        pageSize: 3,
        sortData: " EmployeeId asc",
        additionalWhere: "",
        qID: 0,
        location: "GlobalEmployeeQuery",
        id: "DeductionReportV2",
      },
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    yield put(getReportDataSuccess(response.data.results));
  } catch (error) {
    yield put(getReportDataFailure(error.message));
  }
}

function* CartSaga() {
  yield takeLatest(GET_REPORT_DATA_REQUEST, getEmployeeEarningReportDataSaga);
}

export default CartSaga;
